import axios from "axios";
import store from "../../store/store";
import {actionTypes} from '../../store/ducks/auth.duck';

const apiFF = axios.create({});

function setupAxios(axios, store) {
    axios.interceptors.request.use(config => {
            const {auth: {authToken}} = store.getState();

            if (authToken) {
                config.headers.Authorization = `Bearer ${authToken}`;
            }

            return config;
        },
        err => Promise.reject(err)
    );

    axios.interceptors.response.use(function (response) {
        return response;
    }, function (error) {

        if (error.response.status === 401) {
            store.dispatch({type: actionTypes.Logout, payload: null});
        }

        return Promise.reject(error);
    });
}

setupAxios(apiFF, store);

export default apiFF;